import { FC } from "react"
import { Channel } from "../../../../../types"

interface Props {
  info: Channel
}

const CplCell: FC<Props> = ({ info }) => {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-base font-semibold text-gray-900 tabular-nums">
        ${info.cpl_dollars}
      </span>
      <span className="text-xs text-gray-400 font-medium">/lead</span>
    </div>
  )
}

export default CplCell
